module.exports = __webpack_public_path__ + "img/code.df468219.svg";